import React from "react";

// Floodlit field — ported 1:1 from /design (fieldHTML in render.js).
// Towers + perspective plate + green turf + slate fielders + blue batsmen + white ball.
// Optional: timerPct renders the run-up bar; released animates the ball off the striker.
const FIELD_STD = [
  [150, 0.85], [193, 0.88], [112, 0.72], [84, 0.5], [255, 0.78],
  [300, 0.6], [55, 0.55], [130, 0.45], [332, 0.42], [225, 0.62],
];
const FIELD_DEATH = [
  [60, 0.95], [95, 0.95], [120, 0.95], [150, 0.95], [188, 0.95],
  [212, 0.9], [252, 0.6], [300, 0.55], [145, 0.5], [200, 0.5],
];

// soPos(deg, radiusFraction) -> {l,t} as % inside the plate. deg 0 = top, clockwise.
function soPos(deg, rf) {
  const a = ((deg + 90) * Math.PI) / 180;
  const r = Math.min(rf, 0.94) * 0.43;
  return { l: (0.5 + Math.cos(a) * r) * 100, t: (0.5 + Math.sin(a) * r) * 100 };
}

export function DesignField({ field = "STD", timerPct = null, released = false }) {
  const arr = field === "DEATH" ? FIELD_DEATH : FIELD_STD;
  const lamps = Array.from({ length: 8 });
  return (
    <div className="dfield" data-testid="floodlit-field">
      <div className="field" style={{ height: 200 }}>
        <div className="sky" />
        <div className="tower left">
          <div className="lamps">{lamps.map((_, i) => <i key={i} />)}</div>
          <div className="pole" />
          <div className="beam" />
        </div>
        <div className="tower right">
          <div className="lamps">{lamps.map((_, i) => <i key={i} />)}</div>
          <div className="pole" />
          <div className="beam" />
        </div>
        <div className="plate">
          <div className="halo" />
          <div className="turf"><div className="stripes" /><div className="pools" /></div>
          <div className="rope" />
          <div className="circle30" />
          <div className="strip" />
          {arr.map((f, i) => {
            const p = soPos(f[0], f[1]);
            return <div key={i} className="fielder" style={{ left: p.l.toFixed(1) + "%", top: p.t.toFixed(1) + "%" }} />;
          })}
          <div className="batsman" />
          <div className="nonstriker" />
          <div className={"ball" + (released ? " release" : "")}><i /></div>
        </div>
        <div className="vignette" />
        {timerPct !== null && (
          <div className="runup" data-testid="decision-runup-timer"><i style={{ width: Math.max(0, timerPct) + "%" }} /></div>
        )}
      </div>
    </div>
  );
}
